import { render, staticRenderFns } from "./ThgProofs.vue?vue&type=template&id=484667aa&scoped=true"
import script from "./ThgProofs.vue?vue&type=script&lang=ts"
export * from "./ThgProofs.vue?vue&type=script&lang=ts"
import style0 from "./ThgProofs.vue?vue&type=style&index=0&id=484667aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484667aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCardText,VChip})
